import { postToggle } from "features/social-toggles/data/utils";
import React, { useEffect, useState } from "react";
import ToggleButton from "ui/ToggleButton";

import type { ActionToggleProps } from "./ActionToggle.types";
import { kindConfig } from "./ActionToggle.utils";

const ActionToggle: React.FC<ActionToggleProps> = ({
  kind = "delete",
  objectType,
  objectId,
  isActive = false,
  reason,
  recursive = false,
  onToggle,
}) => {
  const [active, setActive] = useState(isActive);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setActive(isActive);
  }, [isActive]);

  const config = kindConfig[kind];

  const handleToggle = async () => {
    if (!objectType || !objectId || isLoading) return;
    setIsLoading(true);
    const action = active ? config.activeAction : config.inactiveAction;
    const body: Record<string, unknown> = { objectType, id: objectId, action };

    if (reason && !active) body.reason = reason;
    if (recursive) body.recursive = recursive;

    try {
      const data = await postToggle(config.url, body);
      setActive((data?.[config.responseKey] as boolean) ?? !active);
      onToggle?.();
    } catch (error) {
      console.error(`Error ${action} ${objectType}:`, error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ToggleButton
      symbol={active ? config.activeSymbol : config.inactiveSymbol}
      toggled={active}
      loading={isLoading}
      onClick={handleToggle}
    />
  );
};

export default ActionToggle;
